import { useEffect, useState } from 'react';
import { MutationKey, QueryKey, useQueryClient } from 'react-query';

export const useSetInitialData = ({
  withInvalidateQuery = false,
}: {
  withInvalidateQuery: false;
}) => {
  const queryClient = useQueryClient();
  const [initialData, setInitialData] = useState<unknown>();
  const [key, setKey] = useState<QueryKey | MutationKey>();

  useEffect(() => {
    if (key && initialData) {
      queryClient.setQueryData(key, initialData);
      if (withInvalidateQuery) queryClient.invalidateQueries(key);
    }
  }, [key, initialData]);

  return <T>(key: QueryKey | MutationKey, initialData: T): void => {
    setInitialData(initialData);
    setKey(key);
  };
};
